import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import Menu from './Menu';
import LanguageSwitcher from '../LanguageSwitcher';

const Header = ({ onLogin }) => {
    return (
        <header className="bg-white sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    <div className="flex items-center">
                        <Link to="/" className="shrink-0 flex items-center">
                            <img className="h-16 w-auto" src={logo} alt="Cabaza" />
                        </Link>
                    </div>

                    <Menu />

                    {/* Language switcher on the right */}
                    <div className="flex items-center">
                        <LanguageSwitcher />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
